module.exports = __webpack_public_path__ + "img/stay-tune.f35e941d.svg";